export default {"src":"/_next/static/media/charavoile.98836432.svg","height":685,"width":685,"blurWidth":0,"blurHeight":0};